/**
 * Custom Logger Utility
 * Provides logging functionality that can be easily disabled in production
 */

const isDevelopment = process.env.NODE_ENV !== "production";

/**
 * Creates a logger instance with a specific name/context
 * @param {string} name - The name/context of the logger (e.g., component name)
 * @returns {Object} Logger instance with log, error, warn, info, debug methods
 */
export const createLogger = (name) => {
  const prefix = name ? `[${name}]` : "";

  return {
    log: (...args) => {
      if (isDevelopment) {
        // eslint-disable-next-line no-console
        console.log(prefix, ...args);
      }
    },

    error: (...args) => {
      if (isDevelopment) {
        // eslint-disable-next-line no-console
        console.error(prefix, ...args);
      }
    },

    warn: (...args) => {
      if (isDevelopment) {
        // eslint-disable-next-line no-console
        console.warn(prefix, ...args);
      }
    },

    info: (...args) => {
      if (isDevelopment) {
        // eslint-disable-next-line no-console
        console.info(prefix, ...args);
      }
    },

    debug: (...args) => {
      if (isDevelopment) {
        // eslint-disable-next-line no-console
        console.debug(prefix, ...args);
      }
    }
  };
};

// Default logger instance without a name
const logger = createLogger();

export default logger;
